import ColumnsComponent from 'formiojs/components/columns/Columns';
import { checkConditionalityAcrossForms, shouldFieldUseOriginalConditionality } from '../../simple-inputs/extended-field-helper';
import editForm from './modified-columns-component.form';
import { FormioConditionalityUtils } from '../../../../utils/formio-conditionality-utils';

export default class ModifiedColumnsComponent extends ColumnsComponent {
	static editForm = editForm;

	conditionallyVisible(data: any): boolean {
		if (shouldFieldUseOriginalConditionality(this)) {
			return super.conditionallyVisible(data);
		}

		return checkConditionalityAcrossForms(this);
	}

	checkCondition(row: any, data: any) {
		return FormioConditionalityUtils.checkCondition(
			this.component,
			row || this.data,
			data || this.rootValue,
			this.root ? (this.root as any)._form : {},
			this
		);
	}
}
